import { Serializable } from "./Serializable";

export class Transaction implements Serializable<Transaction> {
    cardHolderName: string;
    transactionCode: string;
    transactionDate: any;
    amount: number;
    planId: string;
    planName: string;
    nextRenewalDate: any;
    renewalInfo: string;
    amountDetails: string;
    endingDigits: string;
    expirationDate: string;
    cardType: string;
    nextPayment: number;
    displayNextPayment: boolean;

    constructor() {
    }

    // this will be used for casting JSON to object
    deserialize(input) {
        !!input.planId && (this.planId = input.planId);
        !!input.planName && (this.planName = input.planName);

        if (!!input.subscription) {
            !!input.subscription.transactionCode && (this.transactionCode = input.subscription.transactionCode);
            !!input.subscription.transactionDate && (this.transactionDate = new Date(input.subscription.transactionDate));
            !!input.subscription.costPerPeriod && (this.amount = input.subscription.costPerPeriod);
            !!input.subscription.nextPaymentDate && (this.nextRenewalDate = new Date(input.subscription.nextPaymentDate));
            !!input.subscription.nextPayment && (this.nextPayment = input.subscription.nextPayment);
            !!input.subscription.displayNextPayment && (this.displayNextPayment = input.subscription.displayNextPayment);

            if (!!!!input.subscription.paymentDetails) {
                !!input.subscription.paymentDetails.cardHolderName && (this.cardHolderName = input.subscription.paymentDetails.cardHolderName);
                !!input.subscription.paymentDetails.endingDigits && (this.endingDigits = input.subscription.paymentDetails.endingDigits);
                !!input.subscription.paymentDetails.expirationDate && (this.expirationDate = input.subscription.paymentDetails.expirationDate);
                !!input.subscription.paymentDetails.cardType && (this.cardType = input.subscription.paymentDetails.cardType);
            }
        }

        return this;
    }
}


export class ErrorTransaction implements Serializable<ErrorTransaction> {
    errorCode: string;
    errorMessage: string;
    objectId: number;
    constructor() {
    }

    // this will be used for casting JSON to object
    deserialize(input) {

        !!input.errorCode && (this.errorCode = input.errorCode);
        !!input.errorMessage && (this.errorMessage = input.errorMessage);
        !!input.objectId && (this.objectId = input.objectId);
        return this;
    }
}
